import { service } from '@ember/service';
import MessagingBase from './messaging-base';

export default class MessagingProfile extends MessagingBase {
  @service intl;

  // Overriding the default here as profile is a singleton endpoint
  // and doesn't follow the standard resource url patterns.
  pathForType() {
    return 'profile';
  }

  async updateAwayStatus(profileId, isAway) {
    const url = `${this.host}/profile`;

    const response = await fetch(url, {
      method: 'PATCH',
      headers: this.headers,
      body: JSON.stringify({
        data: {
          type: 'profiles',
          id: profileId,
          attributes: {
            'is_away': isAway,
          },
        },
      }),
    });

    if (!response.ok) {
      throw new Error(this.intl.t('emc.general_error'));
    }

    return response;
  }
}
